import Vue from "vue";
import CoreuiVue from "@coreui/vue";
import axios from "axios";
import App from "./App";
import router from "./router/index";
import { iconsSet as icons } from "./assets/icons/icons.js";
import store from "./store/index";
//import moment from "moment";
// import VueMoment from "vue-moment";

// require("moment/locale/es");
// moment.locale("es");

import locale from "vue2-datatable-component/locale/es";

Vue.prototype.$i18nForDatatable = srcTxt => locale[srcTxt] || srcTxt;

import BackButton from "./customComponents/BackButton.vue";
Vue.component("BackButton", BackButton);

import KlayFileDD from "./customComponents/KlayFileDD.vue";
Vue.component("KlayFileDD", KlayFileDD);

import ChartA from "./views/analytics/chart";
Vue.component("ChartA", ChartA);

import ScrollView from "./customComponents/ScrollView.vue";
Vue.component("ScrollView", ScrollView);

import MultiSelectC from "./customComponents/MultiSelectC";
Vue.component('MultiSelectC', MultiSelectC);

//para meter un filtro customo poner en true :filterableCustom="true"
import vSelectC from "./customComponents/vSelectC";
Vue.component('vSelectC', vSelectC);

String.prototype.toCapitalize = function(){return `${this.charAt(0)}`.toUpperCase()+this.slice(1).toLowerCase()}
Vue.prototype.$formatter = (num, coin = false,replace="", decimals=2) => {
  return (
    (coin ? "$" : "") +
    Number(num)
      .toFixed(decimals)
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
      .replace(replace,"")
  );
};
Vue.prototype.$formatterNumber = (num, decimals=2 ) => {
  return new Intl.NumberFormat('es-MX', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  }).format(num);
};
const countRepSubString = (str,find) => {
  try{
    let cuenta = 0;
    let posicion = `${str}`.indexOf(find);
    while ( posicion !== -1 ) {
      cuenta++;
      posicion = `${str}`.indexOf(find,posicion+1);
    }
    return cuenta
  }
  catch(err){
    debugger
  }
}

Vue.prototype.$OnlyNumber = (str)=>{
  if(countRepSubString(str,'.')>1){
    const [first, ...rest] = str.split('.')
    str = [first||0,rest.join('')].join('.')
  }
  return str.replace(/([^0-9.])/g, '')
}

Object.byString = function(o, s) {
  s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  s = s.replace(/^\./, '');           // strip a leading dot
  var a = s.split('.');
  for (var i = 0, n = a.length; i < n; ++i) {
      var k = a[i];
      if (k in o) {
          o = o[k];
      } else {
          return;
      }
  }
  return o;
}

Vue.use(CoreuiVue);
Vue.use("axios", axios);
// Vue.use(VueMoment);

new Vue({
  el: "#app",
  router,
  store,
  //CIcon component documentation: https://coreui.io/vue/docs/components/icon
  icons,
  template: "<App/>",
  components: {
    App
  }
});
